<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/home.vue'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect()
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      })
    },
  },
}
</script>

<template>
  <Layout class="home--mega">
    <div :class="$style.home">
      <div>
        <img
          src="https://vanished-fe.s3.us-east-2.amazonaws.com/mantle-2-bw-login.png"
          alt="Logo"
        />
        <!-- Check that the SDK client is not currently loading before accessing is methods -->
        <div
          v-if="!$auth.loading"
          class="login--container"
          style="margin-top: 2rem"
        >
          <!-- show login when not authenticated -->
          <a-button
            v-if="!$auth.isAuthenticated"
            type="primary"
            :size="'large'"
            @click="login"
          >
            Login
            <a-icon type="login" />
          </a-button>
          <a-button v-else type="primary" :size="'large'" @click="logout">
            Logout
            <a-icon type="logout" />
          </a-button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.ant-layout-content {
  display: none;
}

section.home--mega .ant-layout-content {
  margin: 0 !important;
}

.home {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .login--container {
    padding-top: 2rem;
  }

  > div {
    text-align: center;
  }

  img {
    max-width: 450px;
  }
}
</style>
